// Read-only row inside the editable items table. Shows confidence dot,
// category, description, size, material, qty, length, section + Edit/Delete
// buttons. Edit flips the parent's local state to render ItemRowEdit.
import { Pencil, Trash2 } from "lucide-react";
import { formatNumber } from "../../../lib/utils";
import type {
  Confidence,
  TakeoffItemDto,
} from "../../../../../shared/types/pipe-takeoff";

const CONFIDENCE_COLOUR: Record<Confidence, string> = {
  high: "var(--bsp-green)",
  medium: "var(--bsp-orange)",
  low: "var(--bsp-red)",
};

interface Props {
  item: TakeoffItemDto;
  busy: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

export function ItemRowView({ item, busy, onEdit, onDelete }: Props) {
  return (
    <tr>
      <td>
        <span
          title={`${item.confidence} (${item.source})`}
          style={{
            display: "inline-block",
            width: 10,
            height: 10,
            borderRadius: 999,
            background: CONFIDENCE_COLOUR[item.confidence],
          }}
        />
      </td>
      <td style={{ fontSize: 12 }}>{item.category}</td>
      <td>{item.description}</td>
      <td className="bsp-mono" style={{ fontSize: 12 }}>
        {item.sizeDn ?? "—"}
        {item.sizeSecondary ? ` × ${item.sizeSecondary}` : ""}
      </td>
      <td style={{ fontSize: 12 }}>{item.material ?? "—"}</td>
      <td className="bsp-mono">{formatNumber(item.quantity, 0)}</td>
      <td className="bsp-mono">
        {item.lengthM === undefined ? "—" : formatNumber(item.lengthM, 2)}
      </td>
      <td className="bsp-mono" style={{ fontSize: 12 }}>{item.sectionId ?? "—"}</td>
      <td style={{ display: "flex", gap: 6 }}>
        <button
          type="button"
          className="bsp-btn bsp-btn-ghost bsp-btn-sm"
          onClick={onEdit}
          title="Edit"
        >
          <Pencil size={14} />
        </button>
        <button
          type="button"
          className="bsp-btn bsp-btn-ghost bsp-btn-sm"
          onClick={onDelete}
          title="Delete"
          disabled={busy}
        >
          <Trash2 size={14} />
        </button>
      </td>
    </tr>
  );
}
